/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Drawer, Select, Input, Tooltip, message } from 'antd';
import { RedoOutlined, PlusOutlined, CloseOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { RCTable, ButtonWrapper } from 'components';
import { ACL, FilterTitle } from 'components/common';
import { Box, Flex, Text } from 'atoms';
import { initialPaginateConfig, ClientListQueries } from 'utils';
import { useQueryParams } from 'hooks';
import { ClientContractsTableConfig } from 'utils/table-config/ClientContractsTableConfig';
import { getListAction } from 'store/pageSlice';
import { FilterAtnButton } from 'utils/commonStyled';

const { Search } = Input;

const LtSearchBar = styled(Search)`
	border: none;
`;

const allOption = {
	value: '',
	label: 'All',
};

const StatusOptions = [
	{ value: 'true', label: 'Active' },
	{ value: 'false', label: 'Inactive' },
];
StatusOptions.unshift(allOption);

function populateOptions(data = [], showAll = true) {
	/**
	 * assign id & value to option list
	 */
	data = data?.map((element) => ({
		value: element?.id,
		label: element?.value,
	}));

	/**
	 * Add All option of array first
	 */
	if (showAll) {
		data.unshift(allOption);
	}

	return data;
}

export default function ClientContractListPage() {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [citiesList, setCitiesList] = useState('');
	const [clientsList, setClientsList] = useState('');
	const [projectsList, setProjectsList] = useState('');
	const [businessUnitsList, setBusinessUnitsList] = useState([]);

	const [open, setOpen] = useState(false);
	const [rowData, setRowData] = useState({});
	const [paginateConfig, setpaginateConfig] = useQueryParams({
		search_type: 'client_contract',
		filterQuery: ClientListQueries,
		business_unit_ids: [],
	});

	// Fix business_unit_ids format on page load/reload
	const formatFixedRef = useRef(false);
	useEffect(() => {
		if (
			!formatFixedRef.current &&
			paginateConfig?.business_unit_ids &&
			typeof paginateConfig.business_unit_ids === 'string' &&
			paginateConfig.business_unit_ids.includes(',')
		) {
			formatFixedRef.current = true;
			const fixedIds = paginateConfig.business_unit_ids
				.split(',')
				.map((businessUnitId) => businessUnitId.trim())
				.filter(Boolean);
			setpaginateConfig((prev) => ({
				...prev,
				business_unit_ids: fixedIds,
			}));
		}
	}, [paginateConfig?.business_unit_ids]);

	useEffect(() => {
		dispatch(getListAction(paginateConfig)).then((res) => {
			let { cities = [], clients = [], projects = [] } = res;

			cities = cities?.map((element) => ({
				value: element,
				label: element,
			}));
			cities.unshift(allOption);

			clients = populateOptions(clients);
			projects = populateOptions(projects);

			setCitiesList(cities);
			setClientsList(clients);
			setProjectsList(projects);
		});
	}, [dispatch, paginateConfig]);

	// Fetch business units
	useEffect(() => {
		dispatch(
			getListAction({
				search_type: 'business_unit',
				limit: 100,
				offset: 0,
			})
		).then((res) => {
			const buOptions = (res?.rows || []).map((bu) => ({
				value: bu.id,
				label: bu.name,
			}));
			// Don't add "All" option for multiple select filters
			setBusinessUnitsList(buOptions);
		});
	}, [dispatch]);

	const StatusValue = paginateConfig?.is_active ? 'Status' : '';
	const UserVal = paginateConfig?.user_type ? 'User Type' : '';
	const cityFilterValue = paginateConfig?.city ? 'City' : '';

	// Helper function to handle business unit IDs (array vs string from URL)
	const getBusinessUnitIds = () => {
		const buIds = paginateConfig?.business_unit_ids;
		let result = [];

		if (Array.isArray(buIds)) {
			result = buIds;
		} else if (buIds) {
			// Handle comma-separated string from URL (e.g., "9,6")
			if (typeof buIds === 'string' && buIds.includes(',')) {
				result = buIds.split(',').map((id) => id.trim());
			} else {
				result = [buIds];
			}
		}

		return result.map((businessUnitId) => String(businessUnitId).trim()).filter(Boolean);
	};

	const businessUnitFilterValue = getBusinessUnitIds().length > 0 ? 'Business Unit' : '';

	const client = paginateConfig?.client_id ? 'Client' : '';
	const project = paginateConfig?.project_id ? 'Project' : '';
	const StatusValueAll = paginateConfig?.is_active === '' ? 'Status' : '';
	const UserAllVal = paginateConfig?.user_type === '' ? 'User Type' : '';
	const clientAll = paginateConfig?.client_id === '' ? 'Client' : '';
	const projectAll = paginateConfig?.project_id === '' ? 'Project' : '';
	const CityAll = paginateConfig?.city === '' ? 'City' : '';

	const paginationArry = [
		cityFilterValue,
		businessUnitFilterValue,
		StatusValue,
		UserVal,
		client,
		project,
		projectAll,
		StatusValueAll,
		UserAllVal,
		clientAll,
		CityAll,
	];
	const validArray = paginationArry.filter((n) => n);
	console.log(validArray.length);

	return (
		<>
			<Flex justifyContent="space-between" mt={3}>
				{/* <Box flex="0 0 35%">
					<SearchBar
						placeholder="Search"
						name="query_str"
						queryValue={paginateConfig?.query_str}
						onSearch={(val) =>
							setpaginateConfig({
								...initialPaginateConfig,
								query_str: val,
								search_type: 'client_contract',
							})
						}
					/>
				</Box> */}
				<Box flex="0 0 20%">
					<LtSearchBar
						enterButton="Search"
						placeholder="Search"
						allowClear
						onSearch={(val) =>
							setpaginateConfig({
								...initialPaginateConfig,
								query_str: val,
								search_type: 'client_contract',
							})
						}
					/>
				</Box>
				<Box flex="0 0 35%" className="filter-hightlight">
					<Box flex="0 0 35%" display="flex">
						<FilterAtnButton
							onClick={() => {
								setOpen(true);
							}}
						>
							FILTERS
						</FilterAtnButton>
						<span className="highlight-list">
							{StatusValue && <span className="ant-tag">{StatusValue} </span>}
							{StatusValueAll && <span className="ant-tag">{StatusValueAll} </span>}
							{projectAll && <span className="ant-tag">{projectAll} </span>}
							{UserVal && <span className="ant-tag">{UserVal} </span>}
							{cityFilterValue && <span className="ant-tag">{cityFilterValue} </span>}
							{businessUnitFilterValue && (
								<span className="ant-tag" style={{ width: '100px' }}>
									{businessUnitFilterValue}
								</span>
							)}
							{client && <span className="ant-tag">{client}</span>}
							{project && <span className="ant-tag">{project} </span>}
							{UserAllVal && <span className="ant-tag">{UserAllVal} </span>}
							{clientAll && <span className="ant-tag">{clientAll} </span>}
							{CityAll && <span className="ant-tag">{CityAll} </span>}
							{validArray.length > 0 && (
								<Tooltip title="Clear filter">
									<CloseOutlined
										className="filter-close-icon"
										onClick={() => {
											window.location = `${window.origin}/client-contracts`;
										}}
									/>
								</Tooltip>
							)}
						</span>
					</Box>
				</Box>
				<Flex>
					<ButtonWrapper
						onClick={() =>
							setpaginateConfig({
								...initialPaginateConfig,
								search_type: 'client_contract',
							})
						}
						icons={<RedoOutlined />}
					>
						SYNC
					</ButtonWrapper>
					<ACL action="create" module="client_contract">
						<ButtonWrapper
							onClick={() => navigate('/client-contracts/add')}
							icons={<PlusOutlined />}
						>
							CREATE
						</ButtonWrapper>
					</ACL>
				</Flex>
			</Flex>
			<Box mt={3}>
				<RCTable
					rowKey="id"
					tableDatas={[rowData, setRowData]}
					togglePaginate={[paginateConfig, setpaginateConfig]}
					dispatchAction={getListAction}
					columns={ClientContractsTableConfig}
				/>
			</Box>

			<Drawer
				className="userList-drawer"
				title={<FilterTitle onClose={() => setOpen(false)} />}
				placement="right"
				closable={false}
				onClose={() => setOpen(false)}
				open={open}
			>
				<Box>
					<Box mb="2rem">
						<Text mb="5px">Status</Text>
						<Select
							showSearch
							style={{ width: '100%' }}
							name="status"
							value={paginateConfig?.is_active}
							onChange={(val) =>
								setpaginateConfig((prev) => ({
									...prev,
									is_active: val,
								}))
							}
							allowClear
							filterOption={(input, option) =>
								option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
							}
							placeholder="Select"
							options={StatusOptions}
						/>
					</Box>
					<Box mb="2rem">
						<Text mb="5px">Business Unit</Text>
						<Select
							mode="multiple"
							showSearch
							style={{ width: '100%' }}
							name="business_unit_ids"
							value={getBusinessUnitIds()}
							onChange={(val) => {
								setpaginateConfig((prev) => ({
									...prev,
									business_unit_ids: val,
								}));
								if (val.length > 0) {
									message.warning(
										'Entities without an association to a Business Unit are not visible.'
									);
								}
							}}
							allowClear
							filterOption={(input, option) =>
								option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
							}
							placeholder="Select"
							options={businessUnitsList}
							maxTagCount="responsive"
						/>
					</Box>
					<Box mb="2rem">
						<Text mb="5px">City</Text>
						<Select
							showSearch
							style={{ width: '100%' }}
							name="city"
							value={paginateConfig?.city}
							onChange={(val) =>
								setpaginateConfig((prev) => ({
									...prev,
									city: val,
								}))
							}
							allowClear
							onClear={() => {
								setpaginateConfig((prev) => ({
									...prev,
									city: '',
									client_name: '',
									project_location_code: '',
									vendor_name: '',
									trip_type: '',
								}));
							}}
							filterOption={(input, option) =>
								option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
							}
							placeholder="Select"
							options={citiesList}
						/>
					</Box>
					<Box mb="2rem">
						<Text mb="5px">Client</Text>
						<Select
							showSearch
							style={{ width: '100%' }}
							name="client_name"
							value={paginateConfig?.client_name}
							onChange={(val) =>
								setpaginateConfig((prev) => ({
									...prev,
									client_id: val,
								}))
							}
							allowClear
							filterOption={(input, option) =>
								option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
							}
							placeholder="Select"
							options={clientsList}
						/>
					</Box>
					<Box mb="2rem">
						<Text mb="5px">Project</Text>
						<Select
							showSearch
							style={{ width: '100%' }}
							name="project_location_code"
							value={paginateConfig?.project_location_code}
							onChange={(val) =>
								setpaginateConfig((prev) => ({
									...prev,
									project_id: val,
								}))
							}
							allowClear
							filterOption={(input, option) =>
								option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
							}
							placeholder="Select"
							options={projectsList}
						/>
					</Box>
					<Box>
						{/* <ButtonWrapper
							marginLeft="auto"
							border="1px solid rgba(237, 108, 2, 0.5)"
							color="#ed6c02"
							onClick={() =>
								setpaginateConfig((prev) => ({
									...prev,
									user_type: 'admin',
								}))
							}
						>
							RESET FILTERS
						</ButtonWrapper> */}
						<ButtonWrapper
							marginLeft="auto"
							border="1px solid rgba(237, 108, 2, 0.5)"
							color="#ed6c02"
							onClick={() => {
								// navigate('/client-list');
								window.location = `${window.origin}/client-contracts`;
							}}
						>
							RESET FILTERS
						</ButtonWrapper>
					</Box>
				</Box>
			</Drawer>
		</>
	);
}
